module.exports = __webpack_public_path__ + "static/media/login-web-bg.fc361c7a.jpg";